<div class="bg-dark">
  <div class="container">
    <div class="row">
      <div class="col">
        <a class="nav-link text-secondary" routerLink="/legal/agb">
          AGB
        </a>
      </div>
      <div class="col">
          <a class="nav-link text-secondary" routerLink="/legal/impressum">
          Impressum
        </a>
      </div>
      <div class="col">
        <a class="nav-link text-secondary" routerLink="/legal/gpdr">
          Datenschutz
        </a>
      </div>
    </div>
  </div>
</div>
